import { ArgsType } from '@nestjs/graphql'
import { BaseGetArgs } from '../base/baseGet.args'

@ArgsType()
export class CategoryGetArgs extends BaseGetArgs<CategoryGetArgs> {
}
